import classNames from "classnames";
import React from "react";
import { CheckBoxInputFieldState } from "@fidget/common/components/form/checkboxInput";
import { mapEventToString } from "@fidget/common/components/form/eventPicker/eventPicker";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { useStore } from "../../../../../models";
import settingsStyles from "../../../../../styles/settings.css";
import { ChipMessageWidget } from "../../../../chip/presets/ChipMessageWidget/ChipMessageWidget";
import { ChipTagGroup } from "../../../../chip/presets/ChipTagGroup/ChipTagGroup";
import { VerticalSeparator } from "../../../settingsForms/separators/verticalSeparator/verticalSeparator";
import { ExistingActionFormType } from "../../types";
import newStyles from "../newEventActionBox/newEventActionBox.css";
import styles from "./existingEventActionBox.css";

interface Props {
  form: ExistingActionFormType;
}
export const ExistingEventActionBox = ({ form }: Props) => {
  const { widget, tagGroup } = useEventActionBoxState(form);

  const renderEventDescription = () => (
    <span className={classNames(settingsStyles["form-content-font"], styles["description-margin"])}>
      {mapEventToString(form.$.event.$)}
    </span>
  );

  const renderResponseDescription = () => (
    <span className={classNames(settingsStyles["form-content-font"], styles["description-margin"])}>
      {form.$.response.$}
    </span>
  );

  return (
    <div className={settingsStyles.form}>
      <div className={classNames(settingsStyles["flex-column"], newStyles["event-col"])}>
        <span className={classNames(settingsStyles["form-label-font"], styles["label-margin"])}>
          {intl.formatMessage("settings.eventActions.form.event")}
        </span>
        {renderEventDescription()}
        {tagGroup && <ChipTagGroup name={tagGroup.name} enabled={tagGroup.enabled} />}
      </div>
      <VerticalSeparator />
      <div className={classNames(settingsStyles["flex-column"], newStyles["response-col"])}>
        <span className={classNames(settingsStyles["form-label-font"], styles["label-margin"])}>
          {intl.formatMessage("settings.eventActions.form.response")}
        </span>
        {renderResponseDescription()}
        <div className={classNames(settingsStyles["input-max-width"])}>
          {widget && <ChipMessageWidget name={widget.name} />}
        </div>
      </div>
      <VerticalSeparator />
      <div className={classNames(settingsStyles["flex-column"], styles["checkbox-col"])}>
        <CheckBoxInputFieldState
          field={form.$.enabled}
          id={`display-${form.$.id.$}`}
          label={intl.formatMessage("settings.eventActions.enable")}
          smallStyle
          displayNoColors
          noMarginBottom
        />
      </div>
    </div>
  );
};

const useEventActionBoxState = (form: ExistingActionFormType) => {
  const { messageWidgetsStore, tagGroupsStore } = useStore();

  const widgetId = form.$.widgetId.$;
  const widget = widgetId && messageWidgetsStore.getAllWidgets().find(({ id }) => id === widgetId);
  const tagGroup = form.$.tagGroupId.$ ? tagGroupsStore.getById(form.$.tagGroupId.$) : undefined;

  return {
    widget,
    tagGroup
  };
};
